__webpack_require__.p = "https://cdn.dashboard.gifty.nl/5318/";